import React, { useState, useEffect, useCallback } from 'react';
import { useAdmin } from '../context/AdminContext';
import { ModalGenerarProyecciones } from '../components/ModalGenerarProyecciones';

import { API } from '../config/api';
import { apiFetch } from '../config/http';

const SERVICIOS_DEFAULT  = ['Diseño','Inspección','Tramites de aprobación','Estudio Hidrológico','Master Plan','Dibujo','Coordinación','Anteproyecto','Esquemático','Otro'];
// v28: TIPOLOGIAS_DEFAULT como [{id, valor}] para alinearse con FK. id=null → backend resuelve por texto.
const TIPOLOGIAS_DEFAULT = [
  { id: null, valor: 'Residencial' },
  { id: null, valor: 'Comercial' },
  { id: null, valor: 'Industrial' },
  { id: null, valor: 'Institucional' },
  { id: null, valor: 'Infraestructura' },
  { id: null, valor: 'Hoteleria' },
  { id: null, valor: 'Mixto' },
  { id: null, valor: 'Hospitalario' }
];
const PROVINCIAS = ['San José','Alajuela','Cartago','Heredia','Guanacaste','Puntarenas','Limón'];
const ESTADOS    = ['Ofertado','Activo','Hold','Terminado'];
const EMPRESAS   = ['JyA Conusa','Cuenta Personal (JCNS)'];

const fmt = (n) => Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const badgeEstado = (estado) => {
  const map = {
    Activo:    { bg: '#eaf3de', color: '#3B6D11' },
    Ofertado:  { bg: '#faeeda', color: '#854F0B' },
    Hold:      { bg: '#FCEBEB', color: '#A32D2D' },
    Terminado: { bg: '#E6F1FB', color: '#185FA5' }
  };
  const s = map[estado] || { bg: '#f0f0f0', color: '#555' };
  return <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 99, fontSize: 11, fontWeight: 500, background: s.bg, color: s.color }}>{estado}</span>;
};

const lineaVacia = (n) => ({ numero_linea: n, descripcion: '', tipo_servicio: 'Diseño', monto: '', exonerado: false });

const formVacio = {
  id_proyecto: '', nombre: '', cliente_id: '', estado: 'Ofertado',
  facturar_con: 'JyA Conusa', orden_compra: '', moneda: 'Dólares',
  fecha_oferta: '', tipologia: '', tipologia_id: '', area_m2: '', codigo_cfia: '',
  observaciones: '',
  nombre_contacto: '', telefono_contacto: '', correo_contacto: '',
  provincia: 'San José', canton: '', distrito: '', direccion: '',
  exonerado: false, codigo_exoneracion: '', fecha_autorizacion: '',
  tiene_oferta: false, oferta_numero_ofs: '',
  lineas: [lineaVacia(1), lineaVacia(2)]
};

// ── Helpers visuales estándar ──────────────────────────────────────────────────
const inputStyle = {
  width: '100%', padding: '8px 12px', border: '1px solid #e0e0e0',
  borderRadius: '8px', fontSize: '13px', outline: 'none',
  boxSizing: 'border-box', fontFamily: 'Segoe UI, sans-serif'
};
const inputReadOnly = {
  ...inputStyle, background: '#f8f9fa', color: '#555', cursor: 'default'
};

const campoVer = (label, valor) => (
  <div>
    <div style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '3px' }}>{label}</div>
    <div style={{ fontSize: '13px', color: valor ? '#012E40' : '#ccc', fontWeight: valor ? '500' : '400' }}>{valor || '—'}</div>
  </div>
);

const hrSep = () => <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '14px 0' }} />;

const seccion = (label) => (
  <div style={{ gridColumn: '1/-1', fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', padding: '8px 0 6px', borderBottom: '2px solid #e8e8e8', marginTop: '8px' }}>{label}</div>
);

const seccionHeredada = (label) => (
  <div style={{ gridColumn: '1/-1', fontSize: '11px', fontWeight: '700', color: '#854F0B', textTransform: 'uppercase', letterSpacing: '0.7px', padding: '8px 0 6px', borderBottom: '2px solid #faeeda', marginTop: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 2v8M8 13v1" stroke="#854F0B" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8" cy="8" r="6.5" stroke="#854F0B" strokeWidth="1.2"/></svg>
    {label} — desde la oferta
  </div>
);

// ── Modal eliminar ─────────────────────────────────────────────────────────────
const ModalEliminar = ({ titulo, descripcion, onConfirm, onCancel }) => (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', width: '380px' }}>
      <div style={{ width: '52px', height: '52px', background: '#FCEBEB', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="#A32D2D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h3 style={{ textAlign: 'center', fontSize: '16px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 8px' }}>{titulo}</h3>
      <p style={{ textAlign: 'center', fontSize: '13px', color: '#666', margin: '0 0 20px', lineHeight: '1.5' }}>
        ¿Eliminar permanentemente <strong>{descripcion}</strong>?<br/>
        Esta acción <strong>no se puede deshacer</strong>.
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button onClick={onCancel} style={{ padding: '8px 20px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>Cancelar</button>
        <button onClick={onConfirm} style={{ padding: '8px 20px', background: '#A32D2D', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Sí, eliminar</button>
      </div>
    </div>
  </div>
);


// ── Sección Proyección de Facturación (pestaña dentro del Panel Ver) ───────────
const SeccionProyeccion = ({ proyectoId, isAdmin, lineasOferta = [], proyectoMoneda, proyectoFacturarCon, ofertaId }) => {
  const [lineas,         setLineas]         = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [error,          setError]          = useState('');
  const [mostrarAgregar, setMostrarAgregar] = useState(false);
  const [editandoId,     setEditandoId]     = useState(null);
  const [saving,         setSaving]         = useState(false);
  const [mostrarGenerar, setMostrarGenerar] = useState(false);
  // Hay items de oferta disponibles -> el item es obligatorio al crear/editar.
  const hayItems = Array.isArray(lineasOferta) && lineasOferta.length > 0;
  // #2: heredar empresa y moneda desde la oferta (cabecera del proyecto).
  // facturar_con usa el nombre canonico unificado en todo el sistema
  // ('JyA Conusa' | 'Cuenta Personal (JCNS)'), igual que Proyectos/Ofertas/Cobros.
  const defFacturarCon = proyectoFacturarCon || 'JyA Conusa';
  const defMoneda      = proyectoMoneda || 'Dólares';
  const empresasOpts   = ['JyA Conusa', 'Cuenta Personal (JCNS)'];
  const monedasOpts    = ['Dólares', 'Colones'];
  const formAddVacio = { fecha_proyectada: '', descripcion: '', facturar_con: defFacturarCon, moneda: defMoneda, monto: '', notas: '', linea_oferta_id: '' };
  const [formAdd,  setFormAdd]  = useState(formAddVacio);
  const [formEdit, setFormEdit] = useState(formAddVacio);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await apiFetch(`${API}/proyeccion-facturacion?proyecto_id=${proyectoId}`);
      const data = await resp.json();
      setLineas(Array.isArray(data) ? data : []);
    } catch (e) { setError('Error cargando proyección: ' + e.message); }
    setLoading(false);
  }, [proyectoId]);

  useEffect(() => { cargar(); }, [cargar]);

  const simbolo = (m) => m === 'Colones' ? '₡' : '$';
  const MESES_ABREV = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  const fmtMes = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return `${MESES_ABREV[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
  };
  const isoDesdeMes = (yyyymm) => (yyyymm ? `${yyyymm}-01` : null);
  const mesDesdeIso = (iso) => (iso ? iso.slice(0, 7) : '');

  const estadoBadge = (estado) => {
    const map = {
      Pendiente: { bg: '#f1f1f1', color: '#545454' },
      Facturado: { bg: '#faeeda', color: '#854F0B' },
      Cobrado:   { bg: '#eaf3de', color: '#3B6D11' }
    };
    const s = map[estado] || { bg: '#f0f0f0', color: '#555' };
    return <span style={{ background: s.bg, color: s.color, padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 500 }}>{estado || '—'}</span>;
  };

  // Resumen por moneda (solo monedas presentes)
  const monedasPresentes = [...new Set(lineas.map(l => l.moneda))].filter(Boolean);
  const resumen = monedasPresentes.map(moneda => {
    const ls = lineas.filter(l => l.moneda === moneda);
    const proyectado = ls.reduce((s, l) => s + (parseFloat(l.monto) || 0), 0);
    const facturado  = ls.filter(l => l.estado_calculado === 'Facturado' || l.estado_calculado === 'Cobrado').reduce((s, l) => s + (parseFloat(l.monto) || 0), 0);
    const cobrado    = ls.filter(l => l.estado_calculado === 'Cobrado').reduce((s, l) => s + (parseFloat(l.monto) || 0), 0);
    return { moneda, proyectado, facturado, cobrado };
  });

  // Línea de oferta seleccionada (objeto completo) según el id del form.
  const itemSeleccionado = (id) => lineasOferta.find(l => String(l.id) === String(id)) || null;

  const guardarNueva = async () => {
    setError('');
    if (hayItems && !formAdd.linea_oferta_id) { setError('Seleccioná el ítem de la oferta.'); return; }
    if (!formAdd.fecha_proyectada) { setError('Seleccioná el mes.'); return; }
    if (!formAdd.monto)            { setError('Ingresá el monto.'); return; }
    const item = itemSeleccionado(formAdd.linea_oferta_id);
    const body = {
      proyecto_id: proyectoId,
      linea_oferta_id: item ? parseInt(item.id) : null,
      item_numero: item ? item.numero_linea : null,
      descripcion: formAdd.descripcion || (item ? (item.descripcion || '') : ''),
      facturar_con: formAdd.facturar_con,
      moneda: formAdd.moneda,
      monto: parseFloat(formAdd.monto) || 0,
      fecha_proyectada: isoDesdeMes(formAdd.fecha_proyectada),
      notas: formAdd.notas || null
    };
    setSaving(true);
    try {
      const resp = await apiFetch(`${API}/proyeccion-facturacion`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await resp.json();
      if (!resp.ok) { setError(data.error || 'Error al guardar'); setSaving(false); return; }
      setFormAdd(formAddVacio);
      setMostrarAgregar(false);
      await cargar();
    } catch (e) { setError('Error de conexión: ' + e.message); }
    setSaving(false);
  };

  const iniciarEdicion = (l) => {
    setError('');
    setMostrarAgregar(false);
    setEditandoId(l.id);
    setFormEdit({
      fecha_proyectada: mesDesdeIso(l.fecha_proyectada),
      descripcion:      l.descripcion   || '',
      facturar_con:     l.facturar_con  || 'JyA Conusa',
      moneda:           l.moneda        || 'Dólares',
      monto:            l.monto         || '',
      notas:            l.notas         || '',
      linea_oferta_id:  l.linea_oferta_id ? String(l.linea_oferta_id) : ''
    });
  };

  const guardarEdicion = async () => {
    setError('');
    if (hayItems && !formEdit.linea_oferta_id) { setError('Seleccioná el ítem de la oferta.'); return; }
    if (!formEdit.fecha_proyectada) { setError('El mes es requerido.'); return; }
    const item = itemSeleccionado(formEdit.linea_oferta_id);
    const body = {
      linea_oferta_id: item ? parseInt(item.id) : null,
      item_numero: item ? item.numero_linea : null,
      descripcion: formEdit.descripcion || (item ? (item.descripcion || '') : ''),
      facturar_con: formEdit.facturar_con,
      moneda: formEdit.moneda,
      monto: parseFloat(formEdit.monto) || 0,
      fecha_proyectada: isoDesdeMes(formEdit.fecha_proyectada),
      notas: formEdit.notas || null
    };
    setSaving(true);
    try {
      const resp = await apiFetch(`${API}/proyeccion-facturacion?id=${editandoId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await resp.json();
      if (!resp.ok) { setError(data.error || 'Error al actualizar'); setSaving(false); return; }
      setEditandoId(null);
      await cargar();
    } catch (e) { setError('Error de conexión: ' + e.message); }
    setSaving(false);
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar esta línea de proyección?')) return;
    setError('');
    try {
      const resp = await apiFetch(`${API}/proyeccion-facturacion?id=${id}&hard=true`, { method: 'DELETE' });
      if (!resp.ok) { const d = await resp.json().catch(() => ({})); setError(d.error || 'Error al eliminar'); return; }
      await cargar();
    } catch (e) { setError('Error de conexión: ' + e.message); }
  };

  const inputMini = {
    width: '100%', padding: '5px 6px', border: '1px solid #ddd', borderRadius: 5,
    fontSize: 11, fontFamily: 'Segoe UI, sans-serif', outline: 'none', boxSizing: 'border-box'
  };
  const inputAdd = { ...inputMini, padding: '6px 8px', borderRadius: 6, fontSize: 12 };

  return (
    <>
      {hrSep()}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px' }}>Proyección de facturación</div>
        {isAdmin && !mostrarAgregar && !editandoId && (
          <div style={{ display: 'flex', gap: 8 }}>
            {hayItems && ofertaId && (
              <button onClick={() => { setError(''); setMostrarGenerar(true); }}
                style={{ padding: '6px 12px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' }}>
                ⚡ Generar proyecciones
              </button>
            )}
            <button onClick={() => { setError(''); setMostrarAgregar(true); }}
              style={{ padding: '6px 12px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' }}>
              + Agregar línea
            </button>
          </div>
        )}
      </div>

      {mostrarGenerar && (
        <ModalGenerarProyecciones
          ofertaId={ofertaId}
          proyectoId={proyectoId}
          moneda={defMoneda}
          facturarCon={defFacturarCon}
          onCerrar={() => setMostrarGenerar(false)}
          onGenerado={() => { setMostrarGenerar(false); cargar(); }}
        />
      )}

      {error && (
        <div style={{ background: '#FCEBEB', border: '1px solid #f5c6c6', borderRadius: '8px', padding: '8px 12px', fontSize: '12px', color: '#A32D2D', marginBottom: '10px' }}>
          {error}
        </div>
      )}

      {loading ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#888', fontSize: '12px' }}>Cargando proyección…</div>
      ) : (
        <>
          {/* Tarjetas resumen (solo monedas con líneas) */}
          {resumen.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${resumen.length}, 1fr)`, gap: '10px', marginBottom: '14px' }}>
              {resumen.map(r => (
                <div key={r.moneda} style={{ background: '#f8f9fa', border: '1px solid #eee', borderRadius: '8px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>{r.moneda}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '3px' }}>
                    <span style={{ color: '#888' }}>Proyectado</span>
                    <span style={{ fontWeight: 600, color: '#012E40' }}>{simbolo(r.moneda)}{fmt(r.proyectado)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '3px' }}>
                    <span style={{ color: '#888' }}>Facturado</span>
                    <span style={{ fontWeight: 600, color: '#854F0B' }}>{simbolo(r.moneda)}{fmt(r.facturado)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                    <span style={{ color: '#888' }}>Cobrado</span>
                    <span style={{ fontWeight: 600, color: '#3B6D11' }}>{simbolo(r.moneda)}{fmt(r.cobrado)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {lineas.length === 0 && !mostrarAgregar ? (
            <div style={{ padding: '24px', textAlign: 'center', color: '#aaa', fontSize: '12px', background: '#fafbfc', borderRadius: '8px' }}>
              Sin líneas de proyección para este proyecto.
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ background: '#f8f9fa' }}>
                  <th style={{ padding: '8px 10px', textAlign: 'left',   fontSize: '10px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee', textTransform: 'uppercase', letterSpacing: '0.5px', width: '90px' }}>Mes</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',   fontSize: '10px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Descripción</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',   fontSize: '10px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee', textTransform: 'uppercase', letterSpacing: '0.5px', width: '110px' }}>Empresa</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right',  fontSize: '10px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee', textTransform: 'uppercase', letterSpacing: '0.5px', width: '140px' }}>Monto</th>
                  <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: '10px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee', textTransform: 'uppercase', letterSpacing: '0.5px', width: '90px'  }}>Estado</th>
                  {isAdmin && <th style={{ padding: '8px 10px', borderBottom: '1px solid #eee', width: '100px' }}></th>}
                </tr>
              </thead>
              <tbody>
                {lineas.map(l => editandoId === l.id ? (
                  <tr key={l.id} style={{ borderBottom: '1px solid #f5f5f5', background: '#fffceb' }}>
                    <td style={{ padding: '6px 8px' }}>
                      <input type="month" value={formEdit.fecha_proyectada}
                        onChange={e => setFormEdit(f => ({ ...f, fecha_proyectada: e.target.value }))} style={inputMini}/>
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {hayItems && (
                        <select value={formEdit.linea_oferta_id}
                          onChange={e => { const id = e.target.value; const it = itemSeleccionado(id);
                            setFormEdit(f => ({ ...f, linea_oferta_id: id, descripcion: f.descripcion || (it ? (it.descripcion || '') : '') })); }}
                          style={{ ...inputMini, background: '#fff', marginBottom: 4, borderColor: formEdit.linea_oferta_id ? '#ddd' : '#e0a800' }}>
                          <option value="">— Ítem de la oferta —</option>
                          {lineasOferta.map(l => (
                            <option key={l.id} value={l.id}>{l.numero_linea}. {l.descripcion || '(sin descripción)'}</option>
                          ))}
                        </select>
                      )}
                      <input value={formEdit.descripcion} placeholder="Descripción"
                        onChange={e => setFormEdit(f => ({ ...f, descripcion: e.target.value }))} style={inputMini}/>
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      {proyectoFacturarCon ? (
                        <div style={{ ...inputMini, background: '#f5f5f5', color: '#012E40', fontWeight: 600, display: 'flex', alignItems: 'center' }}
                             title="Facturar con desde el proyecto (solo lectura)">
                          {proyectoFacturarCon}
                        </div>
                      ) : (
                        <select value={formEdit.facturar_con}
                          onChange={e => setFormEdit(f => ({ ...f, facturar_con: e.target.value }))}
                          style={{ ...inputMini, background: '#fff' }}>
                          {empresasOpts.map(o => <option key={o} value={o}>{o}</option>)}
                        </select>
                      )}
                    </td>
                    <td style={{ padding: '6px 8px' }}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {proyectoMoneda ? (
                          <div style={{ ...inputMini, background: '#f5f5f5', width: 62, color: '#012E40', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                               title="Moneda desde la oferta (solo lectura)">
                            {proyectoMoneda}
                          </div>
                        ) : (
                          <select value={formEdit.moneda}
                            onChange={e => setFormEdit(f => ({ ...f, moneda: e.target.value }))}
                            style={{ ...inputMini, background: '#fff', width: 62 }}>
                            {monedasOpts.map(o => <option key={o} value={o}>{o}</option>)}
                          </select>
                        )}
                        <input type="number" step="0.01" value={formEdit.monto}
                          onChange={e => setFormEdit(f => ({ ...f, monto: e.target.value }))}
                          style={{ ...inputMini, textAlign: 'right' }}/>
                      </div>
                    </td>
                    <td style={{ padding: '6px 10px', textAlign: 'center' }}>{estadoBadge(l.estado_calculado)}</td>
                    <td style={{ padding: '6px 6px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <button onClick={guardarEdicion} disabled={saving}
                        style={{ padding: '4px 9px', background: '#87B749', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer', marginRight: 4 }}>✓</button>
                      <button onClick={() => { setEditandoId(null); setError(''); }}
                        style={{ padding: '4px 9px', background: 'none', color: '#666', border: '1px solid #ddd', borderRadius: 5, fontSize: 12, cursor: 'pointer' }}>✕</button>
                    </td>
                  </tr>
                ) : (
                  <tr key={l.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                    <td style={{ padding: '8px 10px', color: '#012E40', fontWeight: 500 }}>{fmtMes(l.fecha_proyectada)}</td>
                    <td style={{ padding: '8px 10px', color: '#333' }}>{l.descripcion || <span style={{ color: '#ccc' }}>—</span>}</td>
                    <td style={{ padding: '8px 10px', color: '#666' }}>{l.facturar_con}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'right', color: '#333' }}>{simbolo(l.moneda)}{fmt(l.monto)}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'center' }}>{estadoBadge(l.estado_calculado)}</td>
                    {isAdmin && (
                      <td style={{ padding: '8px 10px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <button onClick={() => iniciarEdicion(l)} disabled={!!editandoId || mostrarAgregar}
                          style={{ background: 'none', color: '#012E40', border: 'none', fontSize: 11, cursor: (editandoId || mostrarAgregar) ? 'not-allowed' : 'pointer', marginRight: 10, opacity: (editandoId || mostrarAgregar) ? 0.3 : 1 }}>Editar</button>
                        <button onClick={() => eliminar(l.id)} disabled={!!editandoId || mostrarAgregar}
                          style={{ background: 'none', color: '#A32D2D', border: 'none', fontSize: 15, cursor: (editandoId || mostrarAgregar) ? 'not-allowed' : 'pointer', opacity: (editandoId || mostrarAgregar) ? 0.3 : 1 }}>×</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Agregar línea (inline) */}
          {mostrarAgregar && isAdmin && (
            <div style={{ marginTop: '14px', background: '#fafbfc', border: '1px dashed #d5dbe0', borderRadius: '8px', padding: '12px 14px' }}>
              <div style={{ fontSize: '11px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>Agregar línea</div>
              {hayItems && (
                <div style={{ marginBottom: 8 }}>
                  <select value={formAdd.linea_oferta_id}
                    onChange={e => { const id = e.target.value; const it = itemSeleccionado(id);
                      setFormAdd(f => ({ ...f, linea_oferta_id: id, descripcion: f.descripcion || (it ? (it.descripcion || '') : '') })); }}
                    style={{ ...inputAdd, background: '#fff', borderColor: formAdd.linea_oferta_id ? '#ddd' : '#e0a800' }}>
                    <option value="">— Seleccioná el ítem de la oferta —</option>
                    {lineasOferta.map(l => (
                      <option key={l.id} value={l.id}>{l.numero_linea}. {l.descripcion || '(sin descripción)'}</option>
                    ))}
                  </select>
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr 110px 90px 100px 1fr auto', gap: 6, alignItems: 'center' }}>
                <input type="month" value={formAdd.fecha_proyectada}
                  onChange={e => setFormAdd(f => ({ ...f, fecha_proyectada: e.target.value }))} style={inputAdd}/>
                <input placeholder="Descripción (opc.)" value={formAdd.descripcion}
                  onChange={e => setFormAdd(f => ({ ...f, descripcion: e.target.value }))} style={inputAdd}/>
                {proyectoFacturarCon ? (
                  <div style={{ ...inputAdd, background: '#f5f5f5', color: '#012E40', fontWeight: 600, display: 'flex', alignItems: 'center' }}
                       title="Facturar con desde el proyecto (solo lectura)">
                    {proyectoFacturarCon}
                  </div>
                ) : (
                  <select value={formAdd.facturar_con}
                    onChange={e => setFormAdd(f => ({ ...f, facturar_con: e.target.value }))}
                    style={{ ...inputAdd, background: '#fff' }}>
                    {empresasOpts.map(o => <option key={o} value={o}>{o}</option>)}
                  </select>
                )}
                {proyectoMoneda ? (
                  <div style={{ ...inputAdd, background: '#f5f5f5', color: '#012E40', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                       title="Moneda desde la oferta (solo lectura)">
                    {proyectoMoneda}
                  </div>
                ) : (
                  <select value={formAdd.moneda}
                    onChange={e => setFormAdd(f => ({ ...f, moneda: e.target.value }))}
                    style={{ ...inputAdd, background: '#fff' }}>
                    {monedasOpts.map(o => <option key={o} value={o}>{o}</option>)}
                  </select>
                )}
                <input type="number" step="0.01" placeholder="Monto" value={formAdd.monto}
                  onChange={e => setFormAdd(f => ({ ...f, monto: e.target.value }))} style={{ ...inputAdd, textAlign: 'right' }}/>
                <input placeholder="Notas (opc.)" value={formAdd.notas}
                  onChange={e => setFormAdd(f => ({ ...f, notas: e.target.value }))} style={inputAdd}/>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button onClick={guardarNueva} disabled={saving}
                    style={{ padding: '6px 10px', background: '#87B749', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Guardar</button>
                  <button onClick={() => { setMostrarAgregar(false); setFormAdd(formAddVacio); setError(''); }}
                    style={{ padding: '6px 10px', background: 'none', color: '#666', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

// ── Componente principal ───────────────────────────────────────────────────────
// ── Sección Órdenes de Compra (v43, dentro del Panel Ver) ─────────────────────
const inputOC = { padding: '6px 8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', boxSizing: 'border-box', width: '100%' };
const SeccionOrdenesCompra = ({ proyectoId, isAdmin, proyectoMoneda }) => {
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [agregar, setAgregar] = useState(false);
  const [saving, setSaving]   = useState(false);
  const vacio = { numero_oc: '', monto_sin_iva: '', moneda: proyectoMoneda || 'Dólares', fecha_emision: '', notas: '' };
  const [form, setForm] = useState(vacio);

  const simb = (m) => m === 'Colones' ? '₡' : '$';
  const fmtN = (n) => (n == null || isNaN(n)) ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fFecha = (iso) => iso ? String(iso).slice(0, 10).split('-').reverse().join('/') : '—';

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const r = await apiFetch(`${API}/ordenes-compra?proyecto_id=${proyectoId}`);
      const d = await r.json();
      setOrdenes(d.ordenes || []);
    } catch (e) { setError('Error cargando OCs: ' + e.message); }
    setLoading(false);
  }, [proyectoId]);
  useEffect(() => { cargar(); }, [cargar]);

  const guardar = async () => {
    if (!form.monto_sin_iva || !form.fecha_emision) { setError('Monto sin IVA y fecha son requeridos.'); return; }
    setSaving(true); setError('');
    try {
      const r = await apiFetch(`${API}/ordenes-compra`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, proyecto_id: proyectoId, monto_sin_iva: parseFloat(form.monto_sin_iva) }) });
      const d = await r.json();
      if (!r.ok || d.ok === false) throw new Error(d.error || 'Error al guardar');
      setForm(vacio); setAgregar(false); await cargar();
    } catch (e) { setError(e.message); }
    setSaving(false);
  };

  const anular = async (id) => {
    if (!window.confirm('¿Anular esta orden de compra? (queda como Anulada, no se borra)')) return;
    try { await apiFetch(`${API}/ordenes-compra?id=${id}`, { method: 'DELETE' }); await cargar(); }
    catch (e) { setError(e.message); }
  };

  const badge = (oc) => {
    if (oc.estado === 'Anulada') return { t: 'Anulada', bg: '#eee', c: '#888' };
    if (oc.estado === 'Agotada' || Number(oc.saldo) <= 0.01) return { t: 'OC agotada', bg: '#FDF2E0', c: '#9A6414' };
    return { t: `Saldo ${simb(oc.moneda)}${fmtN(oc.saldo)}`, bg: '#EAF3DE', c: '#3B6D11' };
  };

  return (
    <div style={{ marginTop: '20px', borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px' }}>Órdenes de compra</div>
        {/* v47: agregar OC abierto a cualquier funcionario (anular sigue siendo admin) */}
        {!agregar && <button onClick={() => setAgregar(true)} style={{ padding: '5px 12px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}>+ Agregar OC</button>}
      </div>
      {error && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', marginBottom: '8px' }}>{error}</div>}
      {agregar && (
        <div style={{ background: '#f8f9fa', border: '1px solid #eee', borderRadius: '8px', padding: '12px', marginBottom: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          <input placeholder="N° de OC (opcional)" value={form.numero_oc} onChange={e => setForm(f => ({ ...f, numero_oc: e.target.value }))} style={inputOC} />
          <input type="date" value={form.fecha_emision} onChange={e => setForm(f => ({ ...f, fecha_emision: e.target.value }))} style={inputOC} />
          <input type="number" placeholder="Monto sin IVA" value={form.monto_sin_iva} onChange={e => setForm(f => ({ ...f, monto_sin_iva: e.target.value }))} style={inputOC} />
          <select value={form.moneda} onChange={e => setForm(f => ({ ...f, moneda: e.target.value }))} style={inputOC}>{['Dólares', 'Colones'].map(m => <option key={m} value={m}>{m}</option>)}</select>
          <input placeholder="Notas (opcional)" value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} style={{ ...inputOC, gridColumn: '1 / -1' }} />
          <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <button onClick={() => { setAgregar(false); setForm(vacio); setError(''); }} style={{ padding: '6px 12px', border: '1px solid #ddd', background: '#fff', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
            <button onClick={guardar} disabled={saving} style={{ padding: '6px 12px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', opacity: saving ? 0.6 : 1 }}>{saving ? 'Guardando...' : 'Guardar OC'}</button>
          </div>
          <div style={{ gridColumn: '1 / -1', fontSize: '10.5px', color: '#999' }}>Al guardar, la OC activa anterior de este proyecto pasa a "Agotada" (una sola activa a la vez).</div>
        </div>
      )}
      {loading ? <div style={{ fontSize: '12px', color: '#888' }}>Cargando...</div>
        : ordenes.length === 0 ? <div style={{ fontSize: '12px', color: '#bbb' }}>Sin órdenes de compra registradas.</div>
        : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
          <tbody>
            {ordenes.map(oc => {
              const b = badge(oc);
              return (
                <tr key={oc.id} style={{ borderTop: '1px solid #f3f3f3', opacity: oc.estado === 'Anulada' ? 0.5 : 1 }}>
                  <td style={{ padding: '7px 6px', fontWeight: 600, color: '#012E40' }}>{oc.numero_oc || <span style={{ color: '#bbb' }}>(sin N°)</span>}</td>
                  <td style={{ padding: '7px 6px', color: '#555' }}>{fFecha(oc.fecha_emision)}</td>
                  <td style={{ padding: '7px 6px', textAlign: 'right', color: '#012E40', fontWeight: 600 }}>{simb(oc.moneda)}{fmtN(oc.monto_sin_iva)}</td>
                  <td style={{ padding: '7px 6px' }}><span style={{ background: b.bg, color: b.c, padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: 600 }}>{b.t}</span></td>
                  <td style={{ padding: '7px 6px', color: '#999', fontSize: '10px' }}>{oc.estado}</td>
                  <td style={{ padding: '7px 6px', textAlign: 'right' }}>{isAdmin && oc.estado !== 'Anulada' && <button onClick={() => anular(oc.id)} style={{ border: 'none', background: 'transparent', color: '#A32D2D', cursor: 'pointer', fontSize: '11px' }}>Anular</button>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default function Proyectos() {
  const isAdmin = useAdmin();
  const [proyectos,     setProyectos]    = useState([]);
  const [clientes,      setClientes]     = useState([]);
  const [servicios,     setServicios]    = useState(SERVICIOS_DEFAULT);
  const [tipologias,    setTipologias]   = useState(TIPOLOGIAS_DEFAULT);
  const [loading,       setLoading]      = useState(true);
  const [modal,         setModal]        = useState(false);
  const [editando,      setEditando]     = useState(null);
  const [form,          setForm]         = useState(formVacio);
  const [detalle,       setDetalle]      = useState(null);
  const [error,         setError]        = useState('');
  const [idError,       setIdError]      = useState('');
  const [filtro,        setFiltro]       = useState('');
  const [filtroEst,     setFiltroEst]    = useState('');
  const [filtroEmp,     setFiltroEmp]    = useState('');
  const [modalEliminar, setModalEliminar]= useState(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [rP, rC] = await Promise.all([apiFetch(`${API}/proyectos`), apiFetch(`${API}/clientes`)]);
      setProyectos(await rP.json());
      setClientes(await rC.json());
    } catch { /* silencioso */ }
    setLoading(false);
  }, []);

  const cargarListas = useCallback(async () => {
    try {
      const [rS, rT] = await Promise.all([
        apiFetch(`${API}/listas?lista=tipo_servicio`),
        apiFetch(`${API}/listas?lista=tipologia`)
      ]);
      const srv = await rS.json(); const tip = await rT.json();
      if (srv.length) setServicios(srv.map(d => d.valor));
      // v28: tipologias como objetos {id, valor} para alinearse con FK
      if (tip.length) setTipologias(tip.map(d => ({ id: d.id, valor: d.valor })));
    } catch { /* usa defaults */ }
  }, []);

  useEffect(() => { cargar(); cargarListas(); }, [cargar, cargarListas]);

  const calcTotales = (lineas) => {
    let sub = 0, baseGrav = 0, baseExo = 0;
    (lineas || []).forEach(l => {
      const m = parseFloat(l.monto) || 0;
      sub += m;
      l.exonerado ? (baseExo += m) : (baseGrav += m);
    });
    const iva = baseGrav * 0.13;
    return { sub, baseGrav, baseExo, iva, total: sub + iva };
  };

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setLinea  = (i, k, v) => setForm(f => { const ls = [...f.lineas]; ls[i] = { ...ls[i], [k]: v }; return { ...f, lineas: ls }; });
  const addLinea  = () => setForm(f => ({ ...f, lineas: [...f.lineas, lineaVacia(f.lineas.length + 1)] }));
  const delLinea  = (i) => setForm(f => { if (f.lineas.length <= 1) return f; return { ...f, lineas: f.lineas.filter((_, idx) => idx !== i).map((l, idx) => ({ ...l, numero_linea: idx + 1 })) }; });

  const validarId = async (valor) => {
    if (!valor) { setIdError(''); return; }
    try {
      const todos = await apiFetch(`${API}/proyectos`).then(r => r.json());
      const dup = todos.find(p => p.id_proyecto.toLowerCase() === valor.toLowerCase() && (!editando || p.id !== editando));
      setIdError(dup ? `El ID "${valor}" ya existe en la base de datos.` : '');
    } catch { setIdError(''); }
  };

  const guardar = async () => {
    setError('');
    if (!form.id_proyecto.trim()) { setError('El ID de proyecto es requerido.'); return; }
    if (!form.nombre.trim())      { setError('El nombre del proyecto es requerido.'); return; }
    if (!form.facturar_con)       { setError('Seleccioná la empresa de facturación.'); return; }
    if (idError)                  { setError(idError); return; }

    // v47: el form ya no edita orden_compra (se maneja por la OC estructurada +
    // auto-sync). No enviarlo -> el PUT lo preserva via COALESCE (no lo pisa con el
    // valor stale del form ni con NULL).
    const { orden_compra: _ocLegacy, ...formSinOC } = form;
    const body = {
      ...formSinOC,
      cliente_id: form.cliente_id ? parseInt(form.cliente_id) : null,
      area_m2:    form.area_m2    ? parseFloat(form.area_m2)  : null,
      exonerado:  form.exonerado  ? 1 : 0,
      lineas: form.lineas
        .filter(l => l.descripcion.trim())
        .map((l, i) => ({ ...l, numero_linea: i + 1, monto: parseFloat(l.monto) || 0 }))
    };

    try {
      const url    = editando ? `${API}/proyectos?id=${editando}` : `${API}/proyectos`;
      const method = editando ? 'PUT' : 'POST';
      const resp   = await apiFetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const data   = await resp.json();
      if (!resp.ok) { setError(data.error || 'Error al guardar'); return; }
      setModal(false); cargar();
    } catch (e) { setError('Error de conexión: ' + e.message); }
  };

  const nuevo = () => { setForm(formVacio); setEditando(null); setError(''); setIdError(''); setModal(true); };

  const editar = async (proy) => {
    try {
      const data = await apiFetch(`${API}/proyectos?id=${proy.id}`).then(r => r.json());
      setForm({
        id_proyecto:        data.id_proyecto        || '',
        nombre:             data.nombre             || '',
        cliente_id:         data.cliente_id         || '',
        estado:             data.estado             || 'Ofertado',
        facturar_con:       data.facturar_con       || 'JyA Conusa',
        orden_compra:       data.orden_compra       || '',
        moneda:             data.moneda             || 'Dólares',
        fecha_oferta:       data.fecha_oferta ? data.fecha_oferta.split('T')[0] : '',
        tipologia:          data.tipologia_nombre   || data.tipologia          || '',
        tipologia_id:       data.tipologia_id != null ? String(data.tipologia_id) : '',
        area_m2:            data.area_m2            || '',
        codigo_cfia:        data.codigo_cfia        || '',
        observaciones:      data.observaciones      || '',
        nombre_contacto:    data.nombre_contacto    || '',
        telefono_contacto:  data.telefono_contacto  || '',
        correo_contacto:    data.correo_contacto    || '',
        provincia:          data.provincia          || 'San José',
        canton:             data.canton             || '',
        distrito:           data.distrito           || '',
        direccion:          data.direccion          || '',
        exonerado:          !!data.exonerado,
        codigo_exoneracion: data.codigo_exoneracion || '',
        fecha_autorizacion: data.fecha_autorizacion ? data.fecha_autorizacion.split('T')[0] : '',
        tiene_oferta:       !!data.tiene_oferta,
        oferta_numero_ofs:  data.oferta_numero_ofs  || '',
        lineas: data.lineas && data.lineas.length > 0
          ? data.lineas.map(l => ({ numero_linea: l.numero_linea, descripcion: l.descripcion || '', tipo_servicio: l.tipo_servicio || 'Diseño', monto: l.monto || '', exonerado: !!l.exonerado }))
          : [lineaVacia(1)]
      });
      setEditando(proy.id); setError(''); setIdError(''); setModal(true);
    } catch (e) { alert('Error al cargar: ' + e.message); }
  };

  const confirmarEliminar = async () => {
    if (!modalEliminar) return;
    try {
      const resp = await apiFetch(`${API}/proyectos?id=${modalEliminar.id}&hard=true`, { method: 'DELETE' });
      if (!resp.ok) {
        const d = await resp.json().catch(() => ({}));
        if (resp.status === 409 && d.vinculos) {
          const v = d.vinculos;
          const lineas = [];
          if (v.cotizaciones) lineas.push('  - ' + v.cotizaciones + ' cotizacion(es)');
          if (v.facturas)     lineas.push('  - ' + v.facturas + ' factura(s)');
          if (v.cobros)       lineas.push('  - ' + v.cobros + ' cobro(s)');
          if (v.proyeccion)   lineas.push('  - ' + v.proyeccion + ' linea(s) de proyeccion');
          alert(
            'No se puede eliminar el proyecto:\n' +
            modalEliminar.id_proyecto + ' - ' + modalEliminar.nombre + '\n\n' +
            'Tiene los siguientes vinculos:\n' +
            lineas.join('\n') + '\n\n' +
            "Eliminelos primero o use el estado 'Hold' para sacarlo de la lista activa."
          );
        } else {
          alert('No se pudo eliminar: ' + (d.error || `HTTP ${resp.status}`));
        }
        setModalEliminar(null);
        return;
      }
      setModalEliminar(null); setDetalle(null); cargar();
    } catch (e) { alert('Error al eliminar: ' + e.message); }
  };

  const proyectosFiltrados = proyectos.filter(p => {
    const txt = filtro.toLowerCase();
    return (!txt || p.id_proyecto?.toLowerCase().includes(txt) || p.nombre?.toLowerCase().includes(txt) || p.cliente_nombre?.toLowerCase().includes(txt))
      && (!filtroEst || p.estado === filtroEst)
      && (!filtroEmp || p.facturar_con === filtroEmp);
  });

  const stats = {
    total:     proyectos.length,
    activos:   proyectos.filter(p => p.estado === 'Activo').length,
    ofertados: proyectos.filter(p => p.estado === 'Ofertado').length,
    terminados:proyectos.filter(p => p.estado === 'Terminado').length
  };

  const t = calcTotales(form.lineas);

  // ── RENDER PRINCIPAL ───────────────────────────────────────────────────────
  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1200px' }}>

      {/* Header */}
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '14px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Proyectos</span>
        <button onClick={nuevo} style={{ padding: '8px 16px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
          + Nuevo proyecto
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: 'Total proyectos', valor: stats.total,      color: '#012E40' },
          { label: 'Activos',         valor: stats.activos,    color: '#3B6D11' },
          { label: 'Ofertados',       valor: stats.ofertados,  color: '#854F0B' },
          { label: 'Terminados',      valor: stats.terminados, color: '#185FA5' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '14px 18px' }}>
            <div style={{ fontSize: '11px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
            <div style={{ fontSize: '26px', fontWeight: '700', color: s.color, marginTop: '4px' }}>{s.valor}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
          <svg style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} width="16" height="16" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="#aaa" strokeWidth="1.5"/><path d="M15 15l-3-3" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <input value={filtro} onChange={e => setFiltro(e.target.value)}
            placeholder="Buscar por ID, nombre o cliente..."
            style={{ ...inputStyle, paddingLeft: '38px', borderRadius: '10px' }}/>
        </div>
        <select value={filtroEst} onChange={e => setFiltroEst(e.target.value)}
          style={{ padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '10px', fontSize: '13px', background: '#fff', color: '#555' }}>
          <option value="">Todos los estados</option>
          {ESTADOS.map(e => <option key={e}>{e}</option>)}
        </select>
        <select value={filtroEmp} onChange={e => setFiltroEmp(e.target.value)}
          style={{ padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '10px', fontSize: '13px', background: '#fff', color: '#555' }}>
          <option value="">Todas las empresas</option>
          {EMPRESAS.map(e => <option key={e}>{e}</option>)}
        </select>
      </div>

      {/* Tabla */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden', marginBottom: '16px' }}>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Cargando proyectos...</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '860px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['ID Proyecto','Nombre','Cliente','Facturar con','Moneda','Tipo de proyecto','Estado','Acciones'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: 'left', color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {proyectosFiltrados.length === 0
                ? <tr><td colSpan={8} style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No se encontraron proyectos.</td></tr>
                : proyectosFiltrados.map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid #f3f3f3', cursor: 'pointer' }}
                    onClick={() => apiFetch(`${API}/proyectos?id=${p.id}`).then(r => r.json()).then(setDetalle)}
                    onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '11px 14px', fontWeight: '700', color: '#012E40' }}>{p.id_proyecto}</td>
                    <td style={{ padding: '11px 14px', fontWeight: '600', color: '#1a1a1a', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.nombre}</td>
                    <td style={{ padding: '11px 14px', color: '#555' }}>{p.cliente_nombre || '—'}</td>
                    <td style={{ padding: '11px 14px', color: '#555' }}>{p.facturar_con}</td>
                    <td style={{ padding: '11px 14px', color: '#555' }}>{p.moneda}</td>
                    <td style={{ padding: '11px 14px', color: '#555' }}>{p.tipologia_nombre || p.tipologia || '—'}</td>
                    <td style={{ padding: '11px 14px' }}>{badgeEstado(p.estado)}</td>
                    <td style={{ padding: '11px 14px' }}>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button onClick={e => { e.stopPropagation(); editar(p); }}
                          style={{ padding: '4px 12px', background: 'none', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#555' }}>Editar</button>
                        {isAdmin && (
                          <button onClick={e => { e.stopPropagation(); setModalEliminar(p); }}
                            style={{ padding: '4px 12px', background: 'none', border: '1px solid #fcc', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#A32D2D' }}>Eliminar</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>

      {/* Panel Ver */}
      {detalle && (() => {
        const tot = calcTotales(detalle.lineas);
        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
            <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '760px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div style={{ overflowY: 'auto', padding: '28px' }}>

                {/* Cabecera */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <div>
                    <div style={{ fontSize: '20px', fontWeight: '700', color: '#012E40', marginBottom: '6px' }}>{detalle.nombre}</div>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <span style={{ fontSize: '13px', color: '#888', fontWeight: '500' }}>{detalle.id_proyecto}</span>
                      {badgeEstado(detalle.estado)}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button onClick={() => { setDetalle(null); editar(detalle); }}
                      style={{ padding: '7px 16px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>Editar</button>
                    {isAdmin && (
                      <button onClick={() => { setDetalle(null); setModalEliminar(detalle); }}
                        style={{ padding: '7px 16px', background: 'none', border: '1px solid #fcc', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: '#A32D2D' }}>Eliminar</button>
                    )}
                    <button onClick={() => setDetalle(null)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#aaa', lineHeight: 1 }}>×</button>
                  </div>
                </div>

                {/* Indicador oferta */}
                {detalle.tiene_oferta && (
                  <div style={{ display: 'flex', gap: '8px', padding: '8px 12px', background: '#faeeda', borderRadius: '8px', border: '1px solid #FAC775', fontSize: '12px', color: '#633806', marginBottom: '4px' }}>
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginTop: '1px' }}><path d="M8 3v5M8 11v1" stroke="#854F0B" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8" cy="8" r="6.5" stroke="#854F0B" strokeWidth="1.2"/></svg>
                    Proyecto generado desde la Oferta <strong>{detalle.oferta_numero_ofs}</strong>. Los datos base provienen de esa oferta.
                  </div>
                )}

                {hrSep()}

                {/* Info general */}
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '12px' }}>Información general</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px 24px' }}>
                  {campoVer('Facturar con',   detalle.facturar_con)}
                  {campoVer('Moneda',         detalle.moneda)}
                  {campoVer('Fecha de oferta',detalle.fecha_oferta ? detalle.fecha_oferta.split('T')[0] : null)}
                  {campoVer('Tipo de proyecto',detalle.tipologia_nombre || detalle.tipologia)}
                  {campoVer('Área (m²)',      detalle.area_m2 ? `${detalle.area_m2} m²` : null)}
                  {campoVer('Código CFIA',    detalle.codigo_cfia)}
                  {/* v47: la OC ya no se muestra como texto legacy aca; la seccion
                      "Ordenes de compra" abajo en este mismo panel muestra la OC activa
                      con numero + saldo + estado (fuente unica, maneja anuladas). */}
                  {detalle.exonerado && campoVer('Exoneración', `${detalle.codigo_exoneracion || '—'} (${detalle.fecha_autorizacion ? detalle.fecha_autorizacion.split('T')[0] : '—'})`)}
                </div>

                {detalle.observaciones && (
                  <>
                    {hrSep()}
                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '8px' }}>Observaciones</div>
                    <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6', padding: '10px 14px', background: '#f8f9fa', borderRadius: '8px' }}>{detalle.observaciones}</div>
                  </>
                )}

                {hrSep()}

                {/* Contacto */}
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '12px' }}>Contacto del proyecto</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px 24px' }}>
                  {campoVer('Nombre',   detalle.nombre_contacto)}
                  {campoVer('Teléfono', detalle.telefono_contacto)}
                  <div style={{ gridColumn: '1/-1' }}>{campoVer('Correo', detalle.correo_contacto)}</div>
                </div>

                {hrSep()}

                {/* Ubicación */}
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '12px' }}>Ubicación</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '14px 24px' }}>
                  {campoVer('Provincia', detalle.provincia)}
                  {campoVer('Cantón',   detalle.canton)}
                  {campoVer('Distrito', detalle.distrito)}
                  <div style={{ gridColumn: '1/-1' }}>{campoVer('Dirección', detalle.direccion)}</div>
                </div>

                {/* Líneas */}
                {detalle.lineas && detalle.lineas.length > 0 && (
                  <>
                    {hrSep()}
                    <div style={{ fontSize: '11px', fontWeight: '700', color: '#012E40', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '12px' }}>Ítems de servicio</div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', marginBottom: '10px' }}>
                      <thead>
                        <tr style={{ background: '#f8f9fa' }}>
                          {['#','Descripción','Tipo','Monto','IVA','Total'].map(h => (
                            <th key={h} style={{ padding: '8px 10px', textAlign: h==='Monto'||h==='Total'?'right':h==='IVA'?'center':'left', fontSize: '11px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {detalle.lineas.map(l => {
                          const m = parseFloat(l.monto) || 0;
                          return (
                            <tr key={l.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                              <td style={{ padding: '7px 10px', color: '#aaa', fontSize: '11px' }}>{l.numero_linea}</td>
                              <td style={{ padding: '7px 10px', color: '#333' }}>{l.descripcion}</td>
                              <td style={{ padding: '7px 10px', color: '#666' }}>{l.tipo_servicio}</td>
                              <td style={{ padding: '7px 10px', textAlign: 'right' }}>{fmt(m)}</td>
                              <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                                {l.exonerado
                                  ? <span style={{ background: '#eaf3de', color: '#3B6D11', padding: '1px 7px', borderRadius: '6px', fontSize: '10px', fontWeight: '500' }}>Exo</span>
                                  : <span style={{ color: '#888', fontSize: '11px' }}>13%</span>}
                              </td>
                              <td style={{ padding: '7px 10px', textAlign: 'right', fontWeight: '500', color: l.exonerado ? '#3B6D11' : '#012E40' }}>{fmt(l.exonerado ? m : m * 1.13)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div style={{ background: '#f8f9fa', border: '1px solid #eee', borderRadius: '10px', padding: '14px 18px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                      <div>
                        <div style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '3px' }}>Subtotal</div>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>{fmt(tot.sub)} {detalle.moneda}</div>
                      </div>
                      <div>
                        <div style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '3px' }}>IVA 13%</div>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#854F0B' }}>{fmt(tot.iva)} {detalle.moneda}</div>
                      </div>
                      <div>
                        <div style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '3px' }}>Total proyecto</div>
                        <div style={{ fontSize: '18px', fontWeight: '700', color: '#012E40' }}>{fmt(tot.total)} {detalle.moneda}</div>
                      </div>
                    </div>
                  </>
                )}

                {/* Proyección de facturación */}
                <SeccionProyeccion proyectoId={detalle.id_proyecto} isAdmin={isAdmin} lineasOferta={detalle.lineas || []}
                  proyectoMoneda={detalle.moneda} proyectoFacturarCon={detalle.facturar_con} ofertaId={detalle.oferta_id} />

                {/* Órdenes de compra (v43) — usa el id INT del proyecto */}
                <SeccionOrdenesCompra proyectoId={detalle.id} isAdmin={isAdmin} proyectoMoneda={detalle.moneda} />

              </div>
            </div>
          </div>
        );
      })()}

      {/* Modal formulario */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '860px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

            {/* Header limpio */}
            <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: '17px', fontWeight: '700', color: '#012E40' }}>{editando ? 'Editar proyecto' : 'Nuevo proyecto'}</div>
                <div style={{ fontSize: '12px', color: '#888', marginTop: '3px' }}>
                  {form.tiene_oferta
                    ? `Proyecto generado desde la Oferta ${form.oferta_numero_ofs} — completá los datos adicionales`
                    : 'Completá los datos del proyecto'}
                </div>
              </div>
              <button onClick={() => { if (window.confirm('¿Salir sin guardar?')) setModal(false); }}
                style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#aaa', lineHeight: 1 }}>✕</button>
            </div>

            {/* Cuerpo scrolleable */}
            <div style={{ overflowY: 'auto', padding: '24px', display: 'flex', flexDirection: 'column', gap: '4px' }}>

              {error && (
                <div style={{ background: '#FCEBEB', border: '1px solid #f5c6c6', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#A32D2D', marginBottom: '8px' }}>
                  {error}
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>

                {/* ── Identificación ── */}
                {seccion('Identificación')}
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>
                    ID Proyecto *{form.tiene_oferta && <span style={{ color: '#854F0B', marginLeft: '6px', fontWeight: '400', textTransform: 'none', fontSize: '11px' }}>heredado de oferta</span>}
                  </label>
                  <input
                    style={{ ...inputStyle, borderColor: idError ? '#e74c3c' : '#e0e0e0', ...(form.tiene_oferta ? { background: '#f8f9fa', color: '#555' } : {}) }}
                    value={form.id_proyecto}
                    onChange={e => { if (!form.tiene_oferta) { setF('id_proyecto', e.target.value); setIdError(''); } }}
                    onBlur={e => { if (!form.tiene_oferta) validarId(e.target.value); }}
                    readOnly={form.tiene_oferta}
                    placeholder="Ej: 045-00" />
                  {idError && <div style={{ fontSize: '11px', color: '#A32D2D', marginTop: '3px' }}>{idError}</div>}
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Estado *</label>
                  <select style={{ ...inputStyle, background: '#fff' }} value={form.estado} onChange={e => setF('estado', e.target.value)}>
                    {ESTADOS.map(e => <option key={e}>{e}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>
                    Nombre del proyecto *{form.tiene_oferta && <span style={{ color: '#854F0B', marginLeft: '6px', fontWeight: '400', textTransform: 'none', fontSize: '11px' }}>heredado de oferta</span>}
                  </label>
                  <input
                    style={{ ...inputStyle, ...(form.tiene_oferta ? { background: '#f8f9fa', color: '#555' } : {}) }}
                    value={form.nombre}
                    onChange={e => { if (!form.tiene_oferta) setF('nombre', e.target.value); }}
                    readOnly={form.tiene_oferta}
                    placeholder="Nombre descriptivo" />
                </div>

                {/* ── Cliente y Facturación — heredados si viene de oferta ── */}
                {form.tiene_oferta ? seccionHeredada('Cliente y facturación') : seccion('Cliente y facturación')}
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Cliente</label>
                  {form.tiene_oferta
                    ? <input style={inputReadOnly} value={clientes.find(c => c.id === parseInt(form.cliente_id))?.nombre || '—'} readOnly />
                    : <select style={{ ...inputStyle, background: '#fff' }} value={form.cliente_id} onChange={e => setF('cliente_id', e.target.value)}>
                        <option value="">— Seleccionar cliente —</option>
                        {clientes.map(c => <option key={c.id} value={c.id}>{c.id_cliente} — {c.nombre}</option>)}
                      </select>
                  }
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Facturar con *</label>
                  {form.tiene_oferta
                    ? <input style={inputReadOnly} value={form.facturar_con} readOnly />
                    : <select style={{ ...inputStyle, background: '#fff' }} value={form.facturar_con} onChange={e => setF('facturar_con', e.target.value)}>
                        {EMPRESAS.map(e => <option key={e}>{e}</option>)}
                      </select>
                  }
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Moneda</label>
                  {form.tiene_oferta
                    ? <input style={inputReadOnly} value={form.moneda} readOnly />
                    : <select style={{ ...inputStyle, background: '#fff' }} value={form.moneda} onChange={e => setF('moneda', e.target.value)}>
                        <option>Dólares</option><option>Colones</option>
                      </select>
                  }
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Fecha de oferta</label>
                  {form.tiene_oferta
                    ? <input style={inputReadOnly} value={form.fecha_oferta} readOnly />
                    : <input type="date" style={inputStyle} value={form.fecha_oferta} onChange={e => setF('fecha_oferta', e.target.value)} />
                  }
                </div>
                {/* v47: OC estructurada en el flujo normal (reemplaza el input de texto
                    libre legacy). Proyecto existente -> seccion completa de v43 (agregar
                    OC abierto a funcionarios); proyecto nuevo -> nota (OrdenesCompra necesita
                    el id del proyecto). El texto legacy ya no se edita aca; lo mantiene el
                    auto-sync de /ordenes-compra. */}
                <div style={{ gridColumn: '1 / -1' }}>
                  {editando
                    ? <SeccionOrdenesCompra proyectoId={editando} isAdmin={isAdmin} proyectoMoneda={form.moneda} />
                    : <div style={{ fontSize: '12px', color: '#666', background: '#f8f9fa', border: '1px solid #eee', borderRadius: '8px', padding: '10px 12px' }}>
                        <span style={{ fontWeight: 600, color: '#012E40' }}>Orden de compra:</span> guardá el proyecto primero para registrar la OC con sus datos (N°, monto, moneda, fecha).
                      </div>}
                </div>

                {/* ── Exoneración — exclusivo proyecto ── */}
                {seccion('Exoneración de IVA')}
                <div style={{ gridColumn: '1/-1', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px', borderRadius: '8px', border: form.exonerado ? '1px solid #87B749' : '1px solid #e0e0e0', background: form.exonerado ? '#eaf3de' : '#fafafa' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#333' }}>Proyecto exonerado de IVA</div>
                    <div style={{ fontSize: '11px', color: '#888' }}>Activá para ingresar código y fecha de autorización</div>
                  </div>
                  <label style={{ position: 'relative', display: 'inline-block', width: '40px', height: '22px', flexShrink: 0 }}>
                    <input type="checkbox" checked={form.exonerado} onChange={e => setF('exonerado', e.target.checked)} style={{ opacity: 0, width: 0, height: 0 }} />
                    <span style={{ position: 'absolute', cursor: 'pointer', inset: 0, background: form.exonerado ? '#87B749' : '#ccc', borderRadius: '22px', transition: '.2s' }}>
                      <span style={{ position: 'absolute', height: '16px', width: '16px', left: form.exonerado ? '21px' : '3px', bottom: '3px', background: '#fff', borderRadius: '50%', transition: '.2s' }} />
                    </span>
                  </label>
                </div>
                {form.exonerado && (
                  <div style={{ gridColumn: '1/-1', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 18px', padding: '14px', background: '#eaf3de', borderRadius: '8px', border: '1px solid #87B749' }}>
                    <div>
                      <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Código de exoneración</label>
                      <input style={inputStyle} value={form.codigo_exoneracion} onChange={e => setF('codigo_exoneracion', e.target.value)} placeholder="Ej: EXO-2025-0042" />
                    </div>
                    <div>
                      <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Fecha de autorización</label>
                      <input type="date" style={inputStyle} value={form.fecha_autorizacion} onChange={e => setF('fecha_autorizacion', e.target.value)} />
                    </div>
                  </div>
                )}

                {/* ── Detalles del proyecto — exclusivos ── */}
                {seccion('Detalles del proyecto')}
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Tipo de proyecto</label>
                  {/* v28: combo guarda texto + resuelve id desde lista */}
                  <select style={{ ...inputStyle, background: '#fff' }} value={form.tipologia} onChange={e => {
                    const txt = e.target.value;
                    const sel = tipologias.find(t => t.valor === txt);
                    setForm(f => ({
                      ...f,
                      tipologia: txt,
                      tipologia_id: sel && sel.id != null ? String(sel.id) : ''
                    }));
                  }}>
                    <option value="">— Seleccionar —</option>
                    {tipologias.map(tp => <option key={tp.valor} value={tp.valor}>{tp.valor}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Área del proyecto (m²)</label>
                  <input type="number" style={inputStyle} value={form.area_m2} onChange={e => setF('area_m2', e.target.value)} placeholder="0.00" />
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Código CFIA</label>
                  <input style={inputStyle} value={form.codigo_cfia} onChange={e => setF('codigo_cfia', e.target.value)} placeholder="Ej: CFIA-2025-00123" />
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Observaciones</label>
                  <textarea style={{ ...inputStyle, minHeight: '70px', resize: 'vertical' }} value={form.observaciones} onChange={e => setF('observaciones', e.target.value)} placeholder="Notas internas, condiciones especiales..." />
                </div>

                {/* ── Contacto del proyecto — pre-llenado pero editable ── */}
                {seccion('Contacto del proyecto')}
                {form.tiene_oferta && (
                  <div style={{ gridColumn: '1/-1', display: 'flex', gap: '8px', padding: '8px 12px', background: '#E6F1FB', borderRadius: '8px', border: '1px solid #B5D4F4', fontSize: '12px', color: '#185FA5' }}>
                    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, marginTop: '1px' }}>
                      <circle cx="10" cy="10" r="8.5" stroke="#185FA5" strokeWidth="1.4"/>
                      <path d="M10 9v5M10 7v.5" stroke="#185FA5" strokeWidth="1.6" strokeLinecap="round"/>
                    </svg>
                    Pre-llenado desde la oferta. Podés modificarlo si el contacto del proyecto es diferente al de la oferta.
                  </div>
                )}
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Nombre contacto</label>
                  <input style={inputStyle} value={form.nombre_contacto} onChange={e => setF('nombre_contacto', e.target.value)} />
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Teléfono</label>
                  <input style={inputStyle} value={form.telefono_contacto} onChange={e => setF('telefono_contacto', e.target.value)} />
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Correo electrónico</label>
                  <input type="email" style={inputStyle} value={form.correo_contacto} onChange={e => setF('correo_contacto', e.target.value)} />
                </div>

                {/* ── Ubicación — heredada si viene de oferta ── */}
                {form.tiene_oferta ? seccionHeredada('Ubicación') : seccion('Ubicación')}
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Provincia</label>
                  {form.tiene_oferta
                    ? <input style={inputReadOnly} value={form.provincia} readOnly />
                    : <select style={{ ...inputStyle, background: '#fff' }} value={form.provincia} onChange={e => setF('provincia', e.target.value)}>
                        {PROVINCIAS.map(p => <option key={p}>{p}</option>)}
                      </select>
                  }
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Cantón</label>
                  <input style={form.tiene_oferta ? inputReadOnly : inputStyle} value={form.canton} onChange={e => { if (!form.tiene_oferta) setF('canton', e.target.value); }} readOnly={form.tiene_oferta} />
                </div>
                <div>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Distrito</label>
                  <input style={form.tiene_oferta ? inputReadOnly : inputStyle} value={form.distrito} onChange={e => { if (!form.tiene_oferta) setF('distrito', e.target.value); }} readOnly={form.tiene_oferta} />
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={{ fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' }}>Dirección exacta</label>
                  <input style={form.tiene_oferta ? inputReadOnly : inputStyle} value={form.direccion} onChange={e => { if (!form.tiene_oferta) setF('direccion', e.target.value); }} readOnly={form.tiene_oferta} />
                </div>

                {/* ── Ítems de servicio ── */}
                {seccion('Ítems de servicio')}
                <div style={{ gridColumn: '1/-1', overflowX: 'auto' }}>
                  {form.tiene_oferta ? (
                    <>
                      <div style={{ display: 'flex', gap: '8px', padding: '8px 12px', background: '#faeeda', border: '1px solid #FAC775', borderRadius: '8px', marginBottom: '8px', fontSize: '12px', color: '#633806' }}>
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginTop: '1px' }}><path d="M8 3v5M8 11v1" stroke="#854F0B" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8" cy="8" r="6.5" stroke="#854F0B" strokeWidth="1.2"/></svg>
                        Los honorarios están sincronizados desde la Oferta <strong>{form.oferta_numero_ofs}</strong>. Para modificarlos editá la oferta directamente.
                      </div>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                          <tr style={{ background: '#f8f9fa' }}>
                            {['#','Descripción','Tipo','Monto','IVA','Total'].map(h => (
                              <th key={h} style={{ padding: '7px 8px', textAlign: h==='Monto'||h==='Total'?'right':h==='IVA'?'center':'left', fontSize: '11px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {form.lineas.map((l, i) => {
                            const m = parseFloat(l.monto) || 0;
                            return (
                              <tr key={i} style={{ background: i % 2 === 0 ? '#fafafa' : '#fff' }}>
                                <td style={{ padding: '6px 8px', color: '#aaa', fontSize: '11px' }}>{i + 1}</td>
                                <td style={{ padding: '6px 8px', color: '#333' }}>{l.descripcion}</td>
                                <td style={{ padding: '6px 8px', color: '#666' }}>{l.tipo_servicio}</td>
                                <td style={{ padding: '6px 8px', textAlign: 'right' }}>{fmt(m)}</td>
                                <td style={{ padding: '6px 8px', textAlign: 'center' }}>
                                  {l.exonerado ? <span style={{ background: '#eaf3de', color: '#3B6D11', padding: '1px 7px', borderRadius: '6px', fontSize: '10px', fontWeight: '500' }}>Exo</span> : <span style={{ color: '#888', fontSize: '10px' }}>13%</span>}
                                </td>
                                <td style={{ padding: '6px 8px', textAlign: 'right', fontWeight: '500', color: l.exonerado ? '#3B6D11' : '#012E40' }}>{fmt(l.exonerado ? m : m * 1.13)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                          <tr style={{ background: '#f8f9fa' }}>
                            {['#','Descripción','Tipo','Monto','Exonerado','Total',''].map(h => (
                              <th key={h} style={{ padding: '7px 8px', textAlign: h==='Monto'||h==='Total'?'right':h==='Exonerado'?'center':'left', fontSize: '11px', fontWeight: '600', color: '#888', borderBottom: '1px solid #eee' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {form.lineas.map((l, i) => {
                            const m = parseFloat(l.monto) || 0;
                            return (
                              <tr key={i} style={{ background: i % 2 === 0 ? '#fafafa' : '#fff' }}>
                                <td style={{ padding: '5px 6px', color: '#aaa', fontSize: '11px', width: '24px' }}>{i + 1}</td>
                                <td style={{ padding: '5px 4px' }}><input style={{ ...inputStyle, fontSize: '12px', padding: '5px 7px' }} value={l.descripcion} onChange={e => setLinea(i, 'descripcion', e.target.value)} placeholder={`Fase ${i + 1}...`} /></td>
                                <td style={{ padding: '5px 4px', width: '140px' }}>
                                  <select style={{ ...inputStyle, fontSize: '12px', padding: '5px 7px', background: '#fff' }} value={l.tipo_servicio} onChange={e => setLinea(i, 'tipo_servicio', e.target.value)}>
                                    {servicios.map(sv => <option key={sv}>{sv}</option>)}
                                  </select>
                                </td>
                                <td style={{ padding: '5px 4px', width: '100px' }}><input type="number" style={{ ...inputStyle, fontSize: '12px', padding: '5px 7px', textAlign: 'right' }} value={l.monto} onChange={e => setLinea(i, 'monto', e.target.value)} placeholder="0.00" /></td>
                                <td style={{ padding: '5px 4px', width: '70px', textAlign: 'center' }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                                    <label style={{ position: 'relative', display: 'inline-block', width: '34px', height: '19px' }}>
                                      <input type="checkbox" checked={l.exonerado} onChange={e => setLinea(i, 'exonerado', e.target.checked)} style={{ opacity: 0, width: 0, height: 0 }} />
                                      <span style={{ position: 'absolute', cursor: 'pointer', inset: 0, background: l.exonerado ? '#87B749' : '#ccc', borderRadius: '19px', transition: '.2s' }}>
                                        <span style={{ position: 'absolute', height: '13px', width: '13px', left: l.exonerado ? '18px' : '3px', bottom: '3px', background: '#fff', borderRadius: '50%', transition: '.2s' }} />
                                      </span>
                                    </label>
                                    <span style={{ fontSize: '10px', color: l.exonerado ? '#3B6D11' : '#aaa' }}>{l.exonerado ? 'Exo' : '13%'}</span>
                                  </div>
                                </td>
                                <td style={{ padding: '5px 8px', textAlign: 'right', width: '90px', fontWeight: '500', color: l.exonerado ? '#3B6D11' : '#012E40', fontSize: '12px' }}>{fmt(l.exonerado ? m : m * 1.13)}</td>
                                <td style={{ padding: '5px 4px', width: '24px' }}><button onClick={() => delLinea(i)} style={{ background: 'none', border: 'none', color: '#ccc', fontSize: '16px', cursor: 'pointer' }}>×</button></td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <button onClick={addLinea} style={{ width: '100%', marginTop: '6px', border: '1px dashed #ccc', background: 'none', borderRadius: '8px', padding: '7px', fontSize: '12px', cursor: 'pointer', color: '#888' }}>+ Agregar ítem</button>
                    </>
                  )}

                  {/* Totales */}
                  <div style={{ marginTop: '10px', padding: '12px 14px', background: '#f8f9fa', borderRadius: '8px', fontSize: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#666', marginBottom: '4px' }}><span>Subtotal</span><span>{fmt(t.sub)}</span></div>
                    {t.baseExo > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', color: '#3B6D11', marginBottom: '4px' }}><span>Exonerado</span><span>{fmt(t.baseExo)}</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#854F0B', marginBottom: '4px' }}><span>IVA 13% (base gravada: {fmt(t.baseGrav)})</span><span>{fmt(t.iva)}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600', fontSize: '14px', color: '#012E40', borderTop: '1px solid #ddd', paddingTop: '6px' }}><span>Total</span><span>{fmt(t.total)} {form.moneda}</span></div>
                  </div>
                </div>

              </div>
            </div>

            {/* Footer */}
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '10px', flexShrink: 0 }}>
              <button onClick={() => { if (window.confirm('¿Salir sin guardar?')) setModal(false); }}
                style={{ padding: '9px 20px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px', color: '#555' }}>
                Cancelar
              </button>
              <button onClick={guardar}
                style={{ padding: '9px 24px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                {editando ? 'Guardar cambios' : 'Crear proyecto'}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Modal eliminar */}
      {modalEliminar && (
        <ModalEliminar
          titulo="Eliminar proyecto"
          descripcion={`${modalEliminar.id_proyecto} — ${modalEliminar.nombre}`}
          onConfirm={confirmarEliminar}
          onCancel={() => setModalEliminar(null)}
        />
      )}

    </div>
  );
}
